import { render, staticRenderFns } from "./ProjectSlider.vue?vue&type=template&id=2d460c70&"
import script from "./ProjectSlider.vue?vue&type=script&lang=js&"
export * from "./ProjectSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports